import React from "react";
import Link from "gatsby-link";

import SideSpacing from '../HOC/sidespacing';

const Drawer = props => {

    return ( 
    <div
    id="background"
    className={['z-10', 'fixed', 'w-full', 'h-full', 'transition','pin-l', 'pin-t', 'psb', 'font-bold', 'txtlogo', 'bg-black',
    'md:h-full', 'md:pl-6', 'md:mt-0', 'md:pb-6',
    props.open ? 'sideopen' : 'sideclosed',
    props.open ? 'md:w-full' : 'md:w-0'].join(" ")}>

        <div className="flex flex-col flex-1 h-full w-full mx-6 overflow-hidden md:flex-row md:w-auto">

        <SideSpacing />

        <div className="flex flex-col flex-1 flex-wrap h-auto w-full overflow-hidden justify-end pst my-6">

            <Link
                to="/#work"
                className={['block', 'mt-4', 'mr-6', 'no-underline', 'transition', 'hover:text-pink',
                props.open ? 'text-white' : 'text-transparent'].join(" ")}
            >
                <h1>Work</h1>
            </Link>

            <Link
                to="/#drives"
                className={['block', 'mt-4', 'mr-6', 'no-underline', 'transition', 'hover:text-pink',
                props.open ? 'text-white' : 'text-transparent'].join(" ")}
            >
                <h1>Drive</h1>
            </Link>

            <Link
                to="/#services"
                className={['block', 'mt-4', 'mr-6', 'no-underline', 'transition', 'hover:text-pink',
                props.open ? 'text-white' : 'text-transparent'].join(" ")}
            >
                <h1>Services</h1>
            </Link>

            <Link
                to="/#process"
                className={['block', 'mt-4', 'mr-6', 'no-underline', 'transition', 'hover:text-pink',
                props.open ? 'text-white' : 'text-transparent'].join(" ")}
            >
                <h1>Process</h1>
            </Link>

            <Link
                to="/#team"
                className={['block', 'mt-4', 'mr-6', 'no-underline', 'transition', 'hover:text-pink',
                props.open ? 'text-white' : 'text-transparent'].join(" ")}
            >
                <h1>Team</h1>
            </Link>

            <Link
                to="/#contact"
                className={['block', 'mt-4', 'mr-6', 'no-underline', 'transition', 'hover:text-pink',
                props.open ? 'text-white' : 'text-transparent'].join(" ")}
            >
                <h1>Contact</h1>
            </Link>

    </div>

    </div>

    </div>
  
)};

export default Drawer;


// WEBPACK FOOTER //
// ./src/components/Header/drawer.js